import { Router } from "@angular/router";
import { LoginUsersService } from "./../../Services/login-users.service";
import { CheckoutService } from "./../../Services/checkout.service";
import {
    Component,
    OnInit,
    OnChanges,
    Input,
    AfterViewInit,
} from "@angular/core";

import { EmbryoService } from "../../Services/Embryo.service";
import { TranslateService } from "@ngx-translate/core";
import { StaticPagesService } from "src/app/Services/static-pages.service";

@Component({
    selector: "embryo-PaymentDetailSideBar",
    templateUrl: "./PaymentDetailSideBar.component.html",
    styleUrls: ["./PaymentDetailSideBar.component.scss"],
})
export class PaymentDetailSideBarComponent implements OnInit, OnChanges {
    productList: any;
    popupResponse: any;
    total: number = 0;
    lang: any;
    loading: boolean = false;
    user: any;
    totalCommission: number = 0;
    environmentVariables: any;
    public freeDeliveryStatus: boolean = false;
    public amount: any;
    public discount: any;
    // public exclusive = true;
    public exclusiveLable!: boolean;
    loyaltyData: any;
    redeemAmount = 0;
    wallet_data: any;
    walletAmount = 0;
     flattenedProductList :any =[]
    productlistcopyed:any
    constructor(
        public embryoService: EmbryoService,
        private translate: TranslateService,
        private checkoutService: CheckoutService,
        private auth: LoginUsersService,
        private pagesService: StaticPagesService,
        private router: Router
    ) {
        embryoService.emitLang.subscribe((lang: string) => {
            translate.setDefaultLang(lang);
            this.lang = lang;
        });
    }

    ngOnInit() {
        this.lang = localStorage.getItem("lang");
        this.translate.setDefaultLang(this.lang);
        this.embryoService.productCartSub.subscribe(
            (res) => (this.productList = res)
        );

        this.user = this.auth.getUser();
        this.pagesService.getenvConfig().subscribe((res: any) => {
            this.environmentVariables = res;
        });

        this.getDeliveryFeesData();
        this.getExclusiveStatus();
        if (this.environmentVariables?.LOYALTY_PROVIDER == "sadhan") {
            this.getLoyalty();
        }
        if (this.environmentVariables?.ENABLE_USER_WALLET) {
            this.getWallet();
        }
    }
    getWallet() {
        this.embryoService.getWalletDataEmit().subscribe((res) => {
            if (res) {
                this.wallet_data = res;
                if (
                    this.wallet_data?.use_wallet &&
                    this.wallet_data?.balance > 0
                ) {
                    this.walletAmount = this.wallet_data?.balance;
                } else {
                    this.walletAmount = 0;
                }
            } else {
                this.walletAmount = 0;
            }
        });
    }
    getLoyalty() {
        this.embryoService.getLoyaltyDataEmit().subscribe((res: any) => {
            if (res) {
                this.loyaltyData = res;
                if (this.loyaltyData?.redeemed) {
                    this.redeemAmount = this.loyaltyData?.credit;
                } else {
                    this.redeemAmount = 0;
                }
            } else {
                this.redeemAmount = 0;
            }
        });
    }
    ngOnChanges(): void {
        this.getTotalPrice();
    }

    calculateTotalPrice() {
        let subtotal = 0;
             this.flattenedProductList =[]
       if(this.environmentVariables.SPLIT_CART_BY_VENDOR){
           this.productList.forEach((subArray: any) => {
           if (subArray && subArray.items) {
            this.flattenedProductList.push(...subArray.items);
            }
         });
       this.productlistcopyed  = [...new Set(this.flattenedProductList)];   
        }
        else{
           this.productlistcopyed = this.productList;
        }
        if (this.productlistcopyed && this.productlistcopyed.length) {
            for (const product of this.productlistcopyed) {
                product.discount_price !== null
                    ? (subtotal += product.discount_price)
                    : (subtotal += product.price);
            }
        }
        return subtotal;
    }

    public calculateTotalPrice1() {
        let subtotal = 0;
        if (this.productList && this.productList.length) {
            for (const product of this.productList) {
                if (!this.exclusiveLable) {
                    product.discount_price !== null
                        ? (subtotal += product.discount_price)
                        : (subtotal += product.price);
                } else {
                    product.exclusive_price !== null
                        ? (subtotal += product.exclusive_price)
                        : product.discount_price !== null
                        ? (subtotal += product.discount_price)
                        : (subtotal += product.price);
                }
            }
        }
        return subtotal;
    }

    removeProduct(value: any) {
        let message;
        if (this.lang === "en") {
            message = "Are you sure you want to remove this product?";
        } else {
            message = "هل تريد إزالة المنتج من السلة ؟";
        }

        this.embryoService.confirmationPopup(message).subscribe(
            (rep: any) => {
                if (rep) {
                    this.loading = true;
                    const cartProduct = {
                        reset: false,
                        items: [
                            {
                                id: value.id,
                                amount: "0",
                            },
                        ],
                    };

                    this.checkoutService
                        .addOrUpdateToCart(cartProduct)
                        .subscribe(
                            (rep: any) => {
                                if (rep.code == 200) {
                                    if (!rep?.data?.items.length) {
                                        this.router.navigate([
                                            "/" + this.lang + "/checkout",
                                        ]);
                                        this.getPopupResponse(
                                            rep.data,
                                            "close"
                                        );
                                    } else {
                                        this.embryoService.productCartSub.next(
                                            rep?.data?.items
                                        );
                                        this.productList = rep?.data?.items;
                                        this.productList.forEach(
                                            (element: any) => {
                                                element.quantity =
                                                    element.amount;
                                            }
                                        );
                                    }
                                    this.loading = false;
                                }
                            },
                            () => (this.loading = false)
                        );
                }
            }
            // () => this.getPopupResponse(this.popupResponse, value)
        );
    }

    getPopupResponse(response: any, value: any) {
        if (response) {
            this.embryoService.paymentSidenavOpen = false;
        }
    }

    calculateProductSinglePrice(product: any) {
        let price = 0;

        if (product.discount_price !== null) {
            price = product.discount_price;
        } else {
            price = product.price;
        }
        return price;
    }

    // old code
    // getTotalPrice() {
    //     let total = 0;
    //     this.total = 0;
    //     if (this.productList && this.productList.length > 0) {
    //         for (const product of this.productList) {
    //             if (product.discount_price !== null) {
    //                 total += product.discount_price;
    //             } else {
    //                 total += product.price;
    //             }
    //         }
    //         this.total = total;
    //         if (this.embryoService.promoObject) {
    //             total = this.embryoService.promoObject.free_delivery
    //                 ? total
    //                 : this.embryoService.promoObject.amount -
    //                   total +
    //                   (total + this.embryoService.deliveryFees);
    //         } else {
    //             total += this.embryoService.deliveryFees
    //                 ? this.embryoService.deliveryFees
    //                 : 0;
    //         }
    //     }
    //     return total;
    // }

    // public getTotalPrice() {
    //     let total = 0;
    //     this.total = 0;
    //     if (this.productList && this.productList.length) {
    //         for (const product of this.productList) {
    //             product.discount_price !== null
    //                 ? (total += product.discount_price)
    //                 : (total += product.price);
    //         }
    //         this.total = total;
    //         if (
    //             this.embryoService.promoObject &&
    //             !this.embryoService.promoObject.referal
    //         ) {
    //             total =
    //                 this.embryoService.promoObject.amount +
    //                 (this.embryoService.deliveryFees
    //                     ? this.embryoService.deliveryFees
    //                     : 0);
    //         } else {
    //             total += this.embryoService.deliveryFees
    //                 ? this.embryoService.deliveryFees
    //                 : 0;
    //         }
    //     }
    //     return total;
    // }

  public getTotalPrice() {
        let total = 0;
        this.total = 0;
           this.flattenedProductList =[]
       if(this.environmentVariables.SPLIT_CART_BY_VENDOR){
           this.productList.forEach((subArray: any) => {
           if (subArray && subArray.items) {
            this.flattenedProductList.push(...subArray.items);
            }
         });
       this.productlistcopyed  = [...new Set(this.flattenedProductList)];   
        }
        else{
           this.productlistcopyed = this.productList;
        }
        if (this.productlistcopyed && this.productlistcopyed.length) {
            for (const product of this.productlistcopyed) {
                product.discount_price !== null
                    ? (total += product.discount_price)
                    : (total += product.price);
            }
            this.total = total;
            if (
                this.embryoService.promoObject &&
                !this.embryoService.promoObject.referal
            ) {
                total =
                    this.embryoService.promoObject.amount +
                    (this.embryoService.deliveryFees
                        ? this.embryoService.deliveryFees
                        : 0);
            } else {
                total += this.embryoService.deliveryFees
                    ? this.embryoService.deliveryFees
                    : 0;
            }
            // this.promoObject
            //   ? (total = this.promoObject.amount + (this.deliveryFees ? this.deliveryFees.delivery_fees : 0))
            //   : (total += this.deliveryFees ? this.deliveryFees.delivery_fees : 0);
        }

        return total;
    }




    // calculateTotalCommission() {
    //     let totalCommission = this.productList.map((res: any) =>
    //         JSON.parse(res.commission_amount ? res.commission_amount : 0)
    //     );
    //     if (totalCommission) {
    //         let reducer = (accumulator: any, currentValue: any) =>
    //             accumulator + currentValue;
    //         this.totalCommission = totalCommission.reduce(reducer, 0);
    //         return this.totalCommission;
    //     }
    // }

       calculateTotalCommission() {
        this.flattenedProductList =[]
       if(this.environmentVariables.SPLIT_CART_BY_VENDOR){
           this.productList.forEach((subArray: any) => {
           if (subArray && subArray.items) {
            this.flattenedProductList.push(...subArray.items);
            }
         });
       this.productlistcopyed  = [...new Set(this.flattenedProductList)];   
        }
        else{
           this.productlistcopyed = this.productList;
        }
        let totalCommission = this.productlistcopyed.map((res: any) =>
            JSON.parse(res.commission_amount)
        );
        let reducer = (accumulator: any, currentValue: any) =>
            accumulator + currentValue;
        this.totalCommission = totalCommission.reduce(reducer);
         return this.totalCommission;
    }

    // testClose() {
    //     // this.discount = this.embryoService.deliveryFees;
    // }

    getDeliveryFeesData() {
        this.embryoService.data.subscribe((response: any) => {
            if (response) {
                this.freeDeliveryStatus = response.free_delivery;
                this.amount = response.amount;
                this.discount = response.discount;
            } else {
                this.freeDeliveryStatus = false;
            }
        });
    }

    getExclusiveStatus() {
        this.embryoService.exclusivePromcodeStats.subscribe(
            (response: boolean) => {
                this.exclusiveLable = response;
            }
        );
    }
}
